module.exports = __webpack_public_path__ + "static/00322e56f56762532aecf92117ad95bc.svg";